<template>
  <div class="personnelPage">
     <Slider></Slider>
     <Header></Header>
     <Account></Account>
  </div>
</template>
<script>
  import Slider from '@/components/layout/slider.vue';
  import Header from '@/components/layout/header.vue';
  import Account from '../account.vue';

    export default {
        data() {
            return {
              
            }
        },

        components:{
          Header,Slider,Account
        }
    }
</script>


<style scoped lang="scss">
  .aside{
    float: left;
  }
  .el-header{
    margin-left: 2.87rem;
    /*position: relative;*/
    }
  .account{
    float: left;
    margin: 0.24rem 0 0 0.31rem;
    /*position: absolute;
    top: 1rem;
    left: 3.18rem;*/
  }
</style>




// WEBPACK FOOTER //
// src/views/accountPage/Account.vue